import { tv, type TV, type VariantProps } from "tailwind-variants";

export const textVariant = tv(
  {
    slots: {
      base: ["font-articulat"],
    },
    variants: {
      size: {
        labelSmall: {
          base: ["text-2", "font-medium", "leading-[1.4]", "tracking-normal"],
        },
        labelMedium: {
          base: ["text-3", "font-demibold", "leading-[1.4]", "tracking-normal"],
        },
        labelLarge: {
          base: ["text-4", "font-demibold", "leading-[1.4]", "tracking-normal"],
        },
        labelExtraLarge: {
          base: ["text-5", "font-demibold", "leading-[1.4]", "tracking-tight"],
        },
        bodySmall: {
          base: ["text-3", "font-medium", "leading-[1.4]", "tracking-normal"],
        },
        bodyMedium: {
          base: ["text-4", "font-medium", "leading-[1.4]", "tracking-normal"],
        },
        bodyLarge: {
          base: ["text-5", "font-medium", "leading-[1.4]", "tracking-normal"],
        },
        titleHatSmall: {
          base: ["text-3", "font-medium", "leading-[1.4]", "tracking-normal"],
        },
        titleHatMedium: {
          base: [
            "text-3",
            "font-medium",
            "leading-[1.4]",
            "tracking-normal",
            "lg:text-4",
          ],
        },
        titleSmall: {
          base: [
            "text-4",
            "font-regular",
            "leading-[1.4]",
            "tracking-normal",
            "lg:text-6",
          ],
        },
        titleMedium: {
          base: ["text-7", "font-regular", "leading-[1.4]", "tracking-normal"],
        },
        titleLarge: {
          base: ["text-8", "font-regular", "leading-[1.2]", "tracking-normal"],
        },
        titleExtraLarge: {
          base: [
            "text-6",
            "font-regular",
            "leading-[1.2]",
            "tracking-normal",
            "lg:text-9",
          ],
        },
        displayExtraSmall: {
          base: [
            "text-8",
            "font-regular",
            "leading-none",
            "tracking-display-small",
            "lg:text-10",
          ],
        },
        displaySmall: {
          base: [
            "text-9",
            "font-regular",
            "leading-none",
            "tracking-display-small",
            "lg:text-11",
          ],
        },
        displayMedium: {
          base: ["text-12", "font-regular", "leading-none", "tracking-display"],
        },
        displayLarge: {
          base: [
            "text-11",
            "font-regular",
            "leading-none",
            "tracking-display",
            "lg:text-13",
          ],
        },
        displayExtraLarge: {
          base: [
            "text-11",
            "font-regular",
            "leading-none",
            "tracking-display",
            "lg:text-13",
            "xl:text-14",
          ],
        },
        display2ExtraLarge: {
          base: [
            "text-11",
            "font-regular",
            "leading-none",
            "tracking-display",
            "lg:text-14",
            "xl:text-15",
          ],
        },
        display3ExtraLarge: {
          base: [
            "text-11",
            "font-regular",
            "leading-none",
            "tracking-display",
            "lg:text-14",
            "xl:text-15",
            "2xl:text-16",
          ],
        },
        display4ExtraLarge: {
          base: [
            "text-11",
            "font-regular",
            "leading-none",
            "tracking-display",
            "lg:text-14",
            "xl:text-17",
          ],
        },
      },
      uppercase: {
        true: "uppercase",
      },
      italic: {
        true: "italic",
      },
      weight: {
        light: "font-light",
        normal: "font-regular",
        medium: "font-medium",
        demibold: "font-demibold",
      },
    },
    defaultVariants: {
      uppercase: false,
      italic: false,
    },
  },
  { twMerge: false },
);

export type TextVariantProps = VariantProps<typeof textVariant>;

export type TextReturnVariantProps = ReturnType<typeof textVariant>;
